/**
 * 数字过千转化成k 过百万转换成 M
 * @param value
 */
export function numAbbreviation(value) {
  const formatNum = (num) => {
    const numVal = Number(num.toFixed(1));
    // 判断小数位是否为x.0,如果是则取证
    if (numVal - parseInt(numVal) === 0) {
      return parseInt(numVal);
    } else {
      return numVal;
    }
  };
  if (value >= 1e6) {
    return `${formatNum(value / 1e6)}M`;
  }
  if (value >= 1e3) {
    return `${formatNum(value / 1e3)}K`;
  }
  return value;
}
